import {getParent, getRoot} from 'mobx-state-tree'
import dynamic from 'next/dynamic'
import BasicLoader from '~/components/traffic-tickets/screens/basicLoader'
import {PAYMENT_PROVIDERS, REQUEST_STATUSES} from '~/utilities/constants'
import {overwritePaymentProcessor} from "~/services/payments"
import {getStepFromSlug} from "~/components/traffic-tickets/steps/steps"


const REGION_COURT_SELECTOR_CONFIGURATION = {
  slug: 'region-court',
  Component: dynamic(() => import('./index'), {
    loading: BasicLoader
    // ssr: false
  }),
  validateKeys: ['trafficRegion', 'trafficCourt'],
  validatationTarget: self => self.trafficTickets,
  onEnter: async function onEnter(self) {
    const rootStore = getRoot(self)
    if (!rootStore.trafficSubmission.selectedState.available && !rootStore.trafficSubmission.selectedState.isPQFlowEnabled) {
      self.setIsLoading(true); // prevent flicker while redirecting
      self.setStep(getStepFromSlug('basic-details',rootStore.trafficSubmission.selectedState.available))
    }
    if (
      (!self.trafficRegionsLoadedAll) &&
      (self.trafficRegionsStatus !== REQUEST_STATUSES.loading) &&
      (!self.trafficRegions.length)
    ) {
        try {
          await self.loadRegions()
        } catch (error) {
          if (process.env.WINIT_ENV !== 'test') {
            console.error('error fetching traffic regions for state', error)
          }
          const all = getParent(self)
          all.ui.toasts.addToast({
            message: `Issue fetching traffic regions: ${error}`,
            type: 'ERROR'
          })
        }
      }
      self.setIsLoading(false)
  },
  // eslint-disable-next-line
  onExit: async self => {
    let saved = false
    const rootStore = getRoot(self)
    const {user} = rootStore.auth
    if (user?.paymentProcessor.type !== 'cko') {
      const res = await overwritePaymentProcessor(user, self.trafficTickets[0].locationState)
      if (res.isAffiliatedWithWinitLaw) {
        user.changeKey('paymentProcessor', {type: PAYMENT_PROVIDERS.cko})
      }
    }
    try {
      const TRAFFIC_TICKET_KEYS_TO_SAVE = ["trafficRegion", "trafficCourt", "trafficCounty"]
      const ticketSavePromises = self.trafficTickets.map(ticket => {
        return ticket.updateTicket(TRAFFIC_TICKET_KEYS_TO_SAVE)
      })
      await Promise.all(ticketSavePromises)
      saved = true
    } catch (err) {
      saved = false
      self.showErrorToast(`Issue updating your ticket. Please try again.`)
      if (process.env.WINIT_ENV !== 'test') {
        console.error('error updating ticket with court', err)
      }
    }

    return saved // to allow continue
  }
}

export default REGION_COURT_SELECTOR_CONFIGURATION
